import { ForawrdBackwardButton } from "../../../styled-components/PageHeaderStyles";
import LabelText from "../../../ui/LabelText";
import CloseIcon from "@mui/icons-material/Close";
import ValueGraphChart from "./ValueGraphChart";
import { styled } from "styled-components";
import ValueGraphFilterSection from "./ValueGraphFilterSection";
import { useSearch } from "../../../contexts/PlayerSearchContext";
import LabelNumber from "../../../styled-components/LabelNumber";
import ValueGraphChartForThirds from "./ValueGraphChartForThirds";
import { useLoading } from "../../../contexts/LoadingContext";
import { IValueGraph, IValueSeasonGraphChart } from "../../../types/IValueGraphChart";
import ValueGraphChartForSeasons from "./ValueGraphChartForSeasons";
import SecondaryButton from "../../../ui/SecondaryButton";
import { useState } from "react";
import { fetchTransferValueSeasonBenchmark } from "./ValueGraphUtils";
import SeasonValueGraph from "./SeasonValueGraph";
import { IAttributeDriver } from "../../../types/IValueGraphChart";
import IApiResponse from "../../../types/IApiResponse";
import handleApiResponse from "../../../utils/handleApiResponse";
import apiUrls from "../../../config/apiUrls";
import { postData } from "../../../services/api";
import { useEffect } from "react";

interface FullViewContentProps {
  transferValueData: IValueGraph | undefined;
  transferValueSeasonData : IValueSeasonGraphChart | undefined;
  onClose: () => void;
  isFullView: boolean;
  selectedOption?: string;
  playerId? : number;
  setTransferValueSeasonData : (data : IValueSeasonGraphChart| undefined) => void;
}

const ValueGraphContainer = styled.div`
  border: 1px solid ${({ theme }) => theme.playerDataBorder};
`;
const HeaderContainer = styled.div`
  background: ${({ theme }) => theme.playerCardBackground};
`;
const ValueGraphFullView = styled.div`
  background: ${({ theme }) => theme.playerContentBackground};
`;

const options = ['Matches', 'Seasons'];

const FullViewContent: React.FC<FullViewContentProps> = ({ transferValueData, transferValueSeasonData , onClose, isFullView, selectedOption , playerId , setTransferValueSeasonData }) => {
  const { moduleLoading , startLoading, stopLoading, setModuleLoading } = useLoading();
  const { playerName, isTransferMarket, isVolatility, setIsTransferMarket, setVolatility, setSelectedOption , selectedGraph , setSelectedGraph} = useSearch();
    // const { startLoading, stopLoading, moduleLoading, setModuleLoading } = useLoading();

  // const [transferValueSeason , setTransferValueSeasonData] = useState<IValueSeasonGraphChart | undefined>();
   const [attributesDriverData , setAttributesDriverData] = useState<IAttributeDriver>();
          // const { startLoading, stopLoading, moduleLoading, setModuleLoading } = useLoading();
      
        // const [transferValueSeason , setTransferValueSeasonData] = useState<IValueSeasonGraphChart | undefined>();
        
        useEffect(()=>{
           const fetchAttributeDriver = async () => {
            setModuleLoading(true)
                try {
                  const ApiRequestData = {
                    playerId: playerId,
                    isBySeason: false
                  };
                  const response: IApiResponse<IAttributeDriver> = await postData(apiUrls.AttributeDriver, ApiRequestData);
                  handleApiResponse(
                    response,
                    (atrributesDriverData) => {
                      setModuleLoading(false)
                      setAttributesDriverData(atrributesDriverData)
                    },
                    (error) => {
                      setModuleLoading(false)
                      console.error(error);
                    }
                  );
                } catch (error) {
                  setModuleLoading(false)
                  console.error("Error fetching player attributes data:", error);
                }
              };
              if(selectedGraph === 'Attribute-score'){
                fetchAttributeDriver();
              }
      
        },[playerId,selectedGraph])
  

  const handleOptionsClick = (option : string) =>{
    setSelectedGraph('Football')
    setSelectedOption(option)
    if(!transferValueSeasonData){ fetchTransferValueSeasonBenchmark(setModuleLoading ,setTransferValueSeasonData,playerId!) }
    
  }
  return (
    <div>
      <HeaderContainer className="header-container">
        <div className="player-name">
          <LabelText className="drawer-title expanded-market-value">Market Value</LabelText>
          <LabelNumber className="market-value-player-name">: {playerName}</LabelNumber>
        </div>
        <div className="market-value-buttons">
          &nbsp;
          {options.map(option => (
                                        <SecondaryButton
                                            key={option}
                                            label={option}
                                            isSelected={selectedOption === option}
                                            onClick={() => handleOptionsClick(option)}
                                        />
                                    ))} 
        </div>
        <div className="player-name-cross">
          <ForawrdBackwardButton onClick={onClose}>
            <CloseIcon className="cta-btn-icons" />
          </ForawrdBackwardButton>
        </div>
      </HeaderContainer>
      <ValueGraphFullView className="valuegraph-fullview">
        <ValueGraphContainer className={`value-graph-container ${isFullView && "fullview-container"}`}>
          <ValueGraphFilterSection
            isTransferMarket={isTransferMarket}
            isVolatility={isVolatility}
            toggleTransferMarket={() => setIsTransferMarket(!isTransferMarket)}
            toggleVolatility={() => setVolatility(!isVolatility)}
          />
          {selectedOption === "Matches" && (
            <ValueGraphChart transferValueData={transferValueData} attributesDriverData={attributesDriverData} playerId={playerId} isFullView={true} isLoading={moduleLoading} />
          )}
          {selectedOption === "Seasons" && (
            <ValueGraphChartForSeasons transferValueSeasonData={transferValueSeasonData}  isFullView={true} isLoading={moduleLoading}/>
            // <SeasonValueGraph transferValueSeasonData={transferValueSeasonData}  isFullView={true} isLoading={moduleLoading}/>
          )}
          {selectedOption === "Thirds" && (
            <ValueGraphChartForThirds transferValueData={transferValueData} isFullView={true} isLoading={moduleLoading} />
          )}
        </ValueGraphContainer>
      </ValueGraphFullView>
    </div>
  );
};

export default FullViewContent;
